import React from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { Card, Col, Collapse, Row } from "antd";
import YesOrNoToggleInput from "./YesOrNoToggleInput";

const { Panel } = Collapse;

const selectBreakPoints = {
  xl: 8,
  lg: 8,
  md: 8,
  sm: 8,
  xs: 24,
};

const SpecialConditionsInputs = ({ disabled, isOpen, onIsOpenChange }) => {
  return (
    <Col xl={12} lg={12} md={24} sm={24} xs={24}>
      <Collapse
        ghost
        expandIcon={({ isActive }) => (
          <CaretRightOutlined style={{ fontSize: 16, color: "#265AB1" }} rotate={isActive ? 90 : 0} />
        )}
        activeKey={isOpen}
        onChange={onIsOpenChange}
      >
        <Panel key="true" header="Special Conditions" style={{ background: "white" }}>
          <Card className="noLeftMarginCard">
            <Row gutter={16}>
              <Col {...selectBreakPoints}>
                <YesOrNoToggleInput name="requiresTWIC" label="Requires TWIC" disabled={disabled} />
              </Col>
              <Col {...selectBreakPoints}>
                <YesOrNoToggleInput name="requiresEModal" label="Requires eModal" disabled={disabled} />
              </Col>
              <Col {...selectBreakPoints}>
                <YesOrNoToggleInput name="requiresLotExit" label="Requires Lot Exit" disabled={disabled} />
              </Col>
            </Row>
          </Card>
        </Panel>
      </Collapse>
    </Col>
  );
};

export default SpecialConditionsInputs;
